// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"480":"82f800fd","590":"8df9c9d8"}[chunkId] + ".chunk.js";
};